import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {summaryReasons, saveToHistory} from '../IdfSurfingPackageExpansionSlice';
import BtnWhiteBlackBorderBigSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize';
import EpiContext from '@episerver/spa-core/Spa';
import Config from 'app/Config';
import BtnWhiteBlackBorderSmallSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import {prepareNewWindowUrl} from 'app/utilities/StringHelpers/StringHelpers';
import {isMobile} from 'react-device-detect';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {createReportIdfPackageExtensionGeneralError, createReportIdfPackageExtensionSuccess} from 'app/utilities/reports/createReport';

const SummaryStep = (props) => {
  const reportDWH = () => {
    if (props.idfSurfingPackageExpansion.summaryReason === summaryReasons.SUCCESS) {
      createReportIdfPackageExtensionSuccess(
        props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
        props.userData?.loginData.userDetails.contactNumber,
        props.userData?.loginData.userDetails.IDNumber,
        props.idfSurfingPackageExpansion.selectedPackage?.packageObj?.offerID?.value,
      );
    } else {
      createReportIdfPackageExtensionGeneralError(
        props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
        props.userData?.loginData.userDetails.contactNumber,
        props.userData?.loginData.userDetails.IDNumber,
        props.idfSurfingPackageExpansion.selectedPackage?.packageObj.offerID?.value,
      );
    }
  };
  useEffect(() => {
    reportDWH();
    props.saveToHistory('summary');
  }, []);

  const successContent = {
    image: require('../images/like.svg'),
    title: <span className='summary-title'>תתחדשו!</span>,
    body: (
      <>
        <div className={'summary-success'}>
          <span>
            בקשת מנוי {props.userData?.loginData?.userDetails?.contactNumber} להרחבת חבילת{!isMobile && ' הגלישה'}
          </span>
          <span>
            {' '}
            {isMobile && 'הגלישה '} ל-חבילת בסיס {props.idfSurfingPackageExpansion?.selectedPackage?.dataType}{' '}
            {props.idfSurfingPackageExpansion?.selectedPackage?.dataSize} בעלות חודשית של ₪
            {props.idfSurfingPackageExpansion?.selectedPackage?.packageObj?.price?.value},{' '}
          </span>
          <span>הושלמה בהצלחה!</span>
        </div>
      </>
    ),
    button: (
      <>
        <BtnSubmit
          onclick={() => {
            EpiContext.navigateTo(Config.lobbyUrl);
          }}
          text={'סיום'}
        />
      </>
    ),
  };
  const errorContent = {
    image: require('../images/error.svg'),
    title: isMobile ? (
      <>
        <span className='summary-title'>מצטערים, כרגע לא ניתן לבצע</span>
        <span className='summary-title'>את הפעולה שביקשת</span>
      </>
    ) : (
      <span className='summary-title'>מצטערים, כרגע לא ניתן לבצע את הפעולה שביקשת</span>
    ),
    body: isMobile ? (
      <>
        <span>נציגנו ישמחו לסייע לך</span>
        <div className={'buttons'}>
          <BtnWhiteBlackBorderSmallSize
            onclick={() => prepareNewWindowUrl(`tel:${Config.idfCellcomCenter}`)}
            text={'חייגו 999* לנציג שירות'}
          />
          <BtnWhiteBlackBorderSmallSize
            onclick={() => prepareNewWindowUrl(`tel:${Config.idfCellcomCenterFullNumber}`)}
            text={'חייגו 052-9990777 לנציג שירות'}
          />
        </div>
      </>
    ) : (
      <>
        <span>נציגנו ישמחו לסייע לך</span>
        <span>חייגו 999* או 052-9990777 לנציג שירות</span>
      </>
    ),
    button: (
      <>
        <BtnWhiteBlackBorderBigSize
          onclick={() => {
            EpiContext.navigateTo(Config.lobbyUrl);
          }}
          text={'חזרה לאיזור האישי'}
        />
      </>
    ),
  };
  const seniorContent = {
    image: require('../images/error.svg'),
    title: (
      <>
        <span className='summary-title'>חייל בכיר</span>
      </>
    ),
    body: (
      <>
        <span>הנך חייל בכיר ולכן כבר יש לך את החבילה המקסימלית</span>
      </>
    ),
    button: (
      <>
        <BtnSubmit
          onclick={() => {
            EpiContext.navigateTo(Config.lobbyUrl);
          }}
          text={'הבנתי, תודה'}
        />
      </>
    ),
  };
  const maxPackageContent = {
    image: require('../images/error.svg'),
    title: (
      <>
        <span className='summary-title'>חבילה מקסימלית</span>
      </>
    ),
    body: (
      <>
        <span>כבר יש לך את החבילה המקסימלית</span>
      </>
    ),
    button: (
      <>
        <BtnSubmit
          onclick={() => {
            EpiContext.navigateTo(Config.lobbyUrl);
          }}
          text={'הבנתי, תודה'}
        />
      </>
    ),
  };
  const oldPlanContent = {
    image: require('../images/error.svg'),
    title: (
      <>
        <span className='summary-title'>תכנית ישנה</span>
      </>
    ),
    body: (
      <>
        <span>עליך להירשם לתכנית החדשה כדי להמשיך בפעולה</span>
      </>
    ),
    button: (
      <>
        <BtnSubmit
          onclick={() => {
            EpiContext.navigateTo(Config.lobbyUrl);
          }}
          text={'הבנתי, תודה'}
        />
      </>
    ),
  };

  let content;

  switch (props.idfSurfingPackageExpansion.summaryReason) {
    case summaryReasons.SUCCESS:
      content = successContent;
      break;
    case summaryReasons.SENIOR:
      content = seniorContent;
      break;
    case summaryReasons.MAX_PACKAGE:
      content = maxPackageContent;
      break;
    case summaryReasons.OLD_PLAN:
      content = oldPlanContent;
      break;
    case summaryReasons.ERROR:
      content = errorContent;
      break;
    default:
      content = errorContent;
      break;
  }

  return (
    <div className={'confirmation-summary-content'}>
      <div className={'top-content'}>
        <Image src={content.image} alt={props.idfSurfingPackageExpansion.summaryReason === summaryReasons.SUCCESS ? 'success' : 'error'} />
        {content.title}
      </div>
      <div className={'summary-body'}>{content.body}</div>
      <div className={props.idfSurfingPackageExpansion.summaryReason === summaryReasons.SUCCESS ? 'success-button-box' : 'button-box'}>
        {content.button}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    idfSurfingPackageExpansion: state.IdfSurfingPackageExpansion,
    userData: state.authentication,
  };
};

const mapDispatchToProps = {
  saveToHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(SummaryStep);
